// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const mantineLineChartPropsSchema = z.object({
	h: z.number().optional(),
});
